import React from 'react';

/**
 * Displays instructions for adding providers to the roster.
 */
const InstructionsSection = () => {
  return (
    <div className="flex flex-col gap-3 pb-5 mb-5">
      <h1 className="text-2xl font-bold">Add Providers to Roster</h1>
      <ol className="list-decimal pl-5 text-sm space-y-3">
        <li>
          <b>To add a healthcare professional,</b> search by NPI or name and
          location to select their profile. Enter the last four digits of their
          DEA or license number for validation, and provide their work email
          address (personal domains like Gmail or Yahoo are not accepted).
        </li>
        <li>
          <b>Once verified,</b> the professional can be added to your roster for
          purchase—unless their profile is already sponsored by another entity.
        </li>
        <li>
          <b>After purchasing the subscription,</b> we will contact the
          healthcare professional to authorize the subscription and grant you
          permission to update their Healthgrades profile on their behalf. For
          assistance, please contact{' '}
          <a
            href="mailto:elevatedprofile@healthgrades.com"
            className="text-blue-50"
          >
            elevatedprofile@healthgrades.com
          </a>
          .
        </li>
      </ol>
    </div>
  );
};

export default InstructionsSection;
